import { IS_DEMO_PAPER_MAKING_CUSTOMER_ID } from "@/config/common.js";
export const state = {
    old_tabledata: null,
    is_stmart_om_equipment:sessionStorage.getItem('isStmartOMEquipment') || false, //当前是否是可展示智能运维页面
    is_demonstration_equipment:false, //当前是否是演示的客户
    equipData:{},//当前设备信息
    isRunning:true,//凝汽器运行
    currentState:'stop',//设备运行状态
    visible:false,//智能运维模式Dialog控制
    router_equip_data:{},//跳转使用设备信息
    totalDuration:0,//总时长
    current_obj:{},  //当前机组关联单体设备，测点电流的id,
    isDemonstrationPaperMaking:false || localStorage.getItem("statistics_id") == IS_DEMO_PAPER_MAKING_CUSTOMER_ID,//是否是造纸演示客户
};

export const getters = {
};

export const mutations = {
    set_old_tabledata(state, old_tabledata) {
        state.old_tabledata = old_tabledata
    },
    set_is_stmart_om_equipment(state, data){
        state.is_stmart_om_equipment = data
    },
    set_is_demonstration_equipment(state, data){
        state.is_demonstration_equipment = data
    },
    set_equip_data(state, data) {
        state.equipData = data
    },
    set_is_running(state, data) {
        state.isRunning = data
    },
    set_current_state(state, data) {
        state.currentState = data
    },
    set_visible(state, data) {
        state.visible = data
    },
    set_router_equip_data(state, data) {
        state.router_equip_data = data
    },
    /*总时长修改 */ 
    set_total_duration(state, data) {
        state.totalDuration = data
    },
    /* 当前机组关联单体设备，测点电流的id 修改*/ 
    set_current_obj(state, data) {
        state.current_obj = data
    },
    /* 判断当前客户是否是造纸厂客户 */ 
    setIsDemonstrationPaperMaking(state, data) {
        state.isDemonstrationPaperMaking = data
    },
};

